interface ErrorBannerProps {
  message: string | null;
  style?: React.CSSProperties;
}

export default function ErrorBanner({ message, style }: ErrorBannerProps) {
  if (!message) return null;
  return (
    <div
      role="alert"
      style={{
        background: "#fef2f2",
        border: "1px solid #fecaca",
        borderRadius: 8,
        padding: "10px 14px",
        marginBottom: 16,
        color: "#b91c1c",
        fontSize: 13,
        ...style,
      }}
    >
      {message}
    </div>
  );
}
